export async function getPostLoginPath() {
    return '/subscriptions';
}
